import React from "react";
import {
  TruckIcon,
  BoltIcon,
  ClockIcon,
  HomeIcon,
  CurrencyPoundIcon,
  CalendarDaysIcon,
  WrenchScrewdriverIcon,
  BuildingStorefrontIcon,
  MapPinIcon,
  TagIcon,
  StarIcon,
  ShieldCheckIcon,
  CheckCircleIcon,
  SparklesIcon,
  PhoneIcon,
} from "@heroicons/react/24/outline";

export type IconKey =
  | "TruckIcon" | "BoltIcon" | "ClockIcon" | "HomeIcon"
  | "CurrencyPoundIcon" | "CalendarDaysIcon" | "WrenchScrewdriverIcon"
  | "BuildingStorefrontIcon" | "MapPinIcon" | "TagIcon" | "StarIcon"
  | "ShieldCheckIcon" | "CheckCircleIcon" | "SparklesIcon" | "PhoneIcon";

export const ICON_OPTIONS: { key: IconKey; label: string; Component: React.ComponentType<React.SVGProps<SVGSVGElement>> }[] = [
  { key: "TruckIcon",              label: "Truck",    Component: TruckIcon },
  { key: "BoltIcon",               label: "Bolt",     Component: BoltIcon },
  { key: "ClockIcon",              label: "Clock",    Component: ClockIcon },
  { key: "HomeIcon",               label: "Home",     Component: HomeIcon },
  { key: "CurrencyPoundIcon",      label: "Currency", Component: CurrencyPoundIcon },
  { key: "CalendarDaysIcon",       label: "Calendar", Component: CalendarDaysIcon },
  { key: "WrenchScrewdriverIcon",  label: "Wrench",   Component: WrenchScrewdriverIcon },
  { key: "BuildingStorefrontIcon", label: "Store",    Component: BuildingStorefrontIcon },
  { key: "MapPinIcon",             label: "Location", Component: MapPinIcon },
  { key: "TagIcon",                label: "Tag",      Component: TagIcon },
  { key: "StarIcon",               label: "Star",     Component: StarIcon },
  { key: "ShieldCheckIcon",        label: "Shield",   Component: ShieldCheckIcon },
  { key: "CheckCircleIcon",        label: "Check",    Component: CheckCircleIcon },
  { key: "SparklesIcon",           label: "Sparkles", Component: SparklesIcon },
  { key: "PhoneIcon",              label: "Phone",    Component: PhoneIcon },
];

export const COLOR_OPTIONS: { key: string; label: string }[] = [
  { key: "bg-emerald-100 text-emerald-700", label: "Green" },
  { key: "bg-lime-200 text-lime-700",       label: "Lime" },
  { key: "bg-blue-100 text-blue-700",       label: "Blue" },
  { key: "bg-sky-100 text-sky-700",         label: "Sky" },
  { key: "bg-violet-100 text-violet-700",   label: "Violet" },
  { key: "bg-yellow-100 text-yellow-700",   label: "Yellow" },
  { key: "bg-orange-100 text-orange-700",   label: "Orange" },
  { key: "bg-pink-100 text-pink-700",       label: "Pink" },
  { key: "bg-teal-100 text-teal-700",       label: "Teal" },
  { key: "bg-red-100 text-red-700",         label: "Red" },
  { key: "bg-indigo-100 text-indigo-700",   label: "Indigo" },
  { key: "bg-neutral-200 text-neutral-700", label: "Neutral" },
];

export const DEFAULT_ICON: IconKey = "TruckIcon";
export const DEFAULT_COLOR = "bg-neutral-200 text-neutral-700";

export function resolveIcon(key: string) {
  return ICON_OPTIONS.find((o) => o.key === key)?.Component ?? TruckIcon;
}
